// WARNING: DO NOT EDIT.
import Amplify, { Logger, Hub } from 'aws-amplify';
import Services from 'services';
import {
  DEFAULT_LOGIN_URL,
  SSO_LOGIN_REDIRECT_URL,
  SSO_LOGOUT_REDIRECT_URL
} from 'utilities/url.builder.utils';
export const AWSConfigureAmplify = (): Promise<boolean> => {
  const { location } = window;
  const ENV = process.env;
  const amplifyConfig = {
    Auth: {
      region: ENV.REACT_APP_COGNITO_REGION,
      userPoolId: ENV.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolWebClientId: ENV.REACT_APP_COGNITO_APP_CLIENT_ID,
      oauth: {
        domain: ENV.REACT_APP_COGNITO_DOMAIN,
        scope: ['email', 'openid', 'profile'],
        redirectSignIn: SSO_LOGIN_REDIRECT_URL,
        redirectSignOut: SSO_LOGOUT_REDIRECT_URL,
        responseType: 'code'
      }
    },
    API: {
      endpoints: [
        {
          name: ENV.REACT_APP_RSOTF_API_NAME,
          endpoint: ENV.REACT_APP_RSOTF_API_URL,
          region: ENV.REACT_APP_RSOTF_API_REGION
        },
        {
          name: ENV.REACT_APP_MAP_DATA_SERVICE_NAME,
          endpoint: ENV.REACT_APP_MAP_DATA_SERVICE_URL
        }
      ]
    }
  };

  const logger = new Logger('SWXApp-logger');
  const listener = ({ payload: { event } }: any) => {
    switch (event) {
      case 'cognitoHostedUI_failure':
      case 'customState_failure':
      case 'signIn_failure':
        logger.info('user sign in failed/requested for fogotten password');
        if (location.search.includes('AADB2C90118')) {
          // Azure SSO - Forgot password key
          Services.auth.forgotSSOPassword();
        }
        if (location.search.includes('AADB2C90091')) {
          // Azure SSO - All cancel event key
          location.href = DEFAULT_LOGIN_URL;
        }
        break;
      default:
        break;
    }
  };
  Hub.listen('auth', listener);
  return new Promise((resolve, reject) => {
    try {
      Amplify.configure(amplifyConfig);
      resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

export default AWSConfigureAmplify;
